/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDocumentRequest
 */
export interface CreateDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    file_name: string;
    /**
     * Source object key for the attachment. JWT callers may provide a key
     * in app-api's BLOB_STORE bucket, which ROC copies into its own bucket.
     * Callers using createDocumentUploadUrl provide the ROC key returned by
     * that endpoint.
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    source_blob_s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    content_type: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentRequest
     */
    file_size_bytes: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    document_type: string;
    /**
     * Facility ID of the uploader. Optional for backwards compatibility - defaults to referral sender facility for JWT callers. Invitation callers may only provide their bound recipient facility ID.
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    sender_facility_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentRequest
     */
    page_count?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    original_document_hash?: string;
}

/**
 * Check if a given object implements the CreateDocumentRequest interface.
 */
export function instanceOfCreateDocumentRequest(value: object): value is CreateDocumentRequest {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('source_blob_s3_key' in value) || value['source_blob_s3_key'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    if (!('file_size_bytes' in value) || value['file_size_bytes'] === undefined) return false;
    if (!('document_type' in value) || value['document_type'] === undefined) return false;
    return true;
}

export function CreateDocumentRequestFromJSON(json: any): CreateDocumentRequest {
    return CreateDocumentRequestFromJSONTyped(json, false);
}

export function CreateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'file_name': json['file_name'],
        'source_blob_s3_key': json['source_blob_s3_key'],
        'content_type': json['content_type'],
        'file_size_bytes': json['file_size_bytes'],
        'document_type': json['document_type'],
        'sender_facility_id': json['sender_facility_id'] == null ? undefined : json['sender_facility_id'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        'original_document_hash': json['original_document_hash'] == null ? undefined : json['original_document_hash'],
    };
}

export function CreateDocumentRequestToJSON(json: any): CreateDocumentRequest {
    return CreateDocumentRequestToJSONTyped(json, false);
}

export function CreateDocumentRequestToJSONTyped(value?: CreateDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'file_name': value['file_name'],
        'source_blob_s3_key': value['source_blob_s3_key'],
        'content_type': value['content_type'],
        'file_size_bytes': value['file_size_bytes'],
        'document_type': value['document_type'],
        'sender_facility_id': value['sender_facility_id'],
        'page_count': value['page_count'],
        'original_document_hash': value['original_document_hash'],
    };
}

